const PARAGRAPH_LATEST_VIDEO = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
  ... on LatestVideos {
      id
      heading
      icon
      type
      uuid
      latestVideos {
        nid
        bodyListing
        body
        author
        categories {
          alias
          color
          name
          weight
        }
        memberOnly
        pathAlias
        publishedOn
        summary
        summaryListing
        title
        featuredImage {
          copyright
          crop_image_style_4_3
          ctaBlockLogo
          ctaIconBlockLandscape
          ctaIconBlockSquare
          description
          downloadable
          horizontalCardImage
          latestEpisodeImage
          newsFeaturedImage
          podcastEpisodeImage
          promotionBlockLandscape
          responsiveImage
          promotionBlockLandscapeMedium
          smallPromotionBlockLandscape
        }
      }
    }
  }
`;

export default PARAGRAPH_LATEST_VIDEO;
